import React from "react";
import { useNavigate } from "react-router-dom";

const ViewAdBanner = () => {
        const navigate = useNavigate();
    
    return (
        <>
            <div className="main_title">
                <h1>Advertisement Banner Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/ad-banner")}>Manage Ad Banners</button> - View Advertisement
                </p>
            </div>

            <div className="cards">
                <div className="view_page">
                    <div className="gap_p">

                        {/* ===== Banner Image ===== */}
                        <div className="w_100">
                            <h6>Banner Image</h6>
                            <div className="upload_image_holder no_radius">
                                <figure>
                                    <img
                                        src="/static/images/placeholder.png"
                                        alt="Ad Banner"
                                    />
                                </figure>
                            </div>
                        </div>

                        {/* ===== Basic Details ===== */}
                        <div className="w_33">
                            <h6>Advertisement Title</h6>
                            <p>Monsoon Mega Sale</p>
                        </div>


                        <div className="w_33">
                            <h6>Status</h6>
                            <p>
                                <span className="status_btn c_success">Active</span>
                            </p>
                        </div>

                        {/* ===== Validity and Schedule ===== */}
                        <div className="title_inner">
                            <h2>Validity and Schedule</h2>
                        </div>

                        <div className="w_25">
                            <h6>Start Date & Time</h6>
                            <p>01 Aug 2025, 08:00 AM</p>
                        </div>

                        <div className="w_25">
                            <h6>End Date & Time</h6>
                            <p>07 Aug 2025, 08:00 PM</p>
                        </div>

                        <div className="w_25">
                            <h6>Duration Per Day</h6>
                            <p>Every 2 Hours</p>
                        </div>

                        <div className="w_25">
                            <h6>Total Validity (Days)</h6>
                            <p>7 Days</p>
                        </div>

                        {/* ===== Assigned Vendors and Products ===== */}
                        <div className="title_inner">
                            <h2>Assigned Vendors and Products</h2>
                        </div>

                        <div className="w_50">
                            <h6>Vendors</h6>
                            <ul >
                                <li>Vendor 1 (Ven001)</li>
                                <li>Vendor 2 (Ven002)</li>
                                <li>Vendor 3 (Ven003)</li>
                            </ul>
                        </div>

                        <div className="w_50">
                            <h6>Products</h6>
                            <ul >
                                <li>Product 1 (#Prod001)</li>
                                <li>Product 2 (#Prod002)</li>
                                <li>Product 3 (#Prod003)</li>
                            </ul>
                        </div>

                        {/* ===== Discount Settings ===== */}
                        <div className="title_inner">
                            <h2>Discount Settings</h2>
                        </div>

                        <div className="w_25">
                            <h6>Discount Value</h6>
                            <p>25%</p>
                        </div>

                        <div className="w_25">
                            <h6>Maximum Discount</h6>
                            <p>₹100</p>
                        </div>

                        <div className="w_25">
                            <h6>Minimum Order Amount</h6>
                            <p>₹500</p>
                        </div>

                        <div className="w_25">
                            <h6>Product Limit for Discount</h6>
                            <p>10 Items</p>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewAdBanner;
